module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('transition', {
    attrs: {
      "name": _vm.transName
    }
  }, [_c('router-view', {
    staticClass: "view"
  })], 1)], 1), _vm._v(" "), _c('menulist', {
    attrs: {
      "is-show": _vm.menuStatus
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-536ae0dc!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 35
// module chunks = 1